import {ConfigurateurContext} from "../../context/context";
import styled from "styled-components";
import {computeDXFPrice, computePrice, computeTransportPrice, computeWeight, getPriceTTC} from "../../helper/function";
import {device} from "../../helper/constants";

const {
    element: {
        useContext,
        useEffect,
    },
} = wp;

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: end;
  
    & .ttc {
      font-size: 24px;
      font-weight: bold;
    }
  
    & .ht {
      font-size: 20px;
    }
  
    & .tt {
      font-size: 15px;
      color: green;
    }
    @media ${device.mobile} {
        width: auto;
        flex-direction: column;
        margin-left: 20px;
        & .ht {
          display: none;
        }
    }
`;
export default function PriceView () {

    const {currentShade, currentMaterial, type, thickness, form, dimensions, quantity, option, price, setPrice, setBasePrice, setTransportPrice,} = useContext(ConfigurateurContext);

    useEffect(() => {
        const weight = computeWeight(type, dimensions, currentShade, thickness);
        const basePrice = computePrice(currentMaterial, currentShade, type, thickness, form, dimensions, 1, option);
        // Transport
        const transportPrice = computeTransportPrice(currentMaterial, weight * quantity);

        const newPrice = (parseFloat(basePrice) * quantity) +  transportPrice;

        const newPriceTTC = getPriceTTC(newPrice);

        setPrice(newPriceTTC);
        setBasePrice(basePrice);
        setTransportPrice(transportPrice);
    }, [quantity]);

    return (
        <Wrapper>
            <span className="ttc">{price} € TTC</span>
            {/*<span className="ht"> {computePrice(currentMaterial, currentShade, type, thickness, form, dimensions, quantity, option)} € HT</span>*/}
            <span className='tt'>Livraison incluse</span>
        </Wrapper>
    )
}